// Priority assays that should appear first in search results
export const PRIORITY_ASSAY_IDS = [589, 590, 1454];

// Panel IDs to exclude from the panel selector
export const EXCLUDED_PANEL_IDS = [52, 14, 13];

// LocalStorage keys
export const STORAGE_KEYS = {
  NORM_INDEX: 'normsPage-indexOfNorm',
  LAST_VIEWED_ID: 'catalog-lastViewedId',
  SELECTED_PANEL: 'catalog-selectedPanel',
  ID_REG: 'idReg',
  IS_DOCTOR: 'isDoctor',
};

// Debounce delay for search input (ms)
export const SEARCH_DEBOUNCE_MS = 300;

// Row height constants for virtualized list
export const ROW_HEIGHT = {
  MIN: 56,
  MAX: 200,
  GROUP_HEADER: 50,
};

// Breakpoints for responsive design (px)
export const BREAKPOINTS = {
  MOBILE: 900,
  SMALL_MOBILE: 600,
  TABLET_MAX: 1150,
};

// Layout dimensions for row height calculation (px)
export const LAYOUT = {
  SCROLLBAR_WIDTH: 17,
  FIXED_COLUMNS_WIDTH_DESKTOP: 480,
  FIXED_COLUMNS_WIDTH_MOBILE: 210,
  CELL_PADDING: 10,
};

// Typography constants for row height calculation
// Based on Inter font measurements for Cyrillic text
export const TYPOGRAPHY = {
  AVG_CHAR_WIDTH_DESKTOP: 9.0,    // Inter 16px, кирилиця
  AVG_CHAR_WIDTH_TABLET: 8.2,     // Inter 14-16px
  AVG_CHAR_WIDTH_MOBILE: 7.8,     // Inter 14px
  LINE_HEIGHT_DESKTOP: 24,
  LINE_HEIGHT_MOBILE: 18,
  WORD_WRAP_BUFFER: 1.12,         // 12% буфер для переносів
};

// Filling list typography for complex research height calculation
export const FILLING_TYPOGRAPHY = {
  LINE_HEIGHT: 17,
  CHARS_PER_LINE_DESKTOP: 60,
  CHARS_PER_LINE_TABLET: 40,
  CHARS_PER_LINE_MOBILE: 30,
};
